import React from "react";
import { Col } from "react-bootstrap";
import { Fade } from "react-reveal";

function RecipeShared(props) {
  return (
    <Col
      lg={props.colSize}
      md={props.mdSize}
      sm={props.smSize}
      xs={props.xsSize}
    >
      <Fade duration={2000}>
        <a
          style={{ color: props.color }}
          className="recipe-link"
          href={"/recipe/" + props.id}
        >
          <img
            src={props.imageLink}
            className="home-recipe-img"
            alt={props.title}
          />
          <h5 className="recipe-title recipe-xs-title">{props.title}</h5>
        </a>
      </Fade>
    </Col>
  );
}

export default RecipeShared;
